<template>
  <div>
    <div class="d-flex justify-content-between mb-3">
      <div class="title-product__availability">
        {{ $t('promotion.promotion_list') }}
      </div>
      <div class="ml-auto d-flex">
        <a-button
          size="large"
          class="mr-2"
          :disabled="loadingSyncPromotion"
          @click="handleSyncPromotion()"
        >
          <a-icon 
            type="sync" 
            class="mr-2" 
            :spin="loadingSyncPromotion"
          />
          {{ loadingSyncPromotion ? $t('promotion.syncing_promotion') : $t('promotion.sync_promotion') }}
        </a-button>
        <a-button
          size="large"
          type="primary"
          @click="$router.push({
            path: `/promotion-channel/${$route.params.id}/create`,
            query: {
              ...$route.query,
            }
          })"
        >
          <a-icon type="plus" class="mr-2" style="font-size:20px" />
          {{ $t('promotion.add_promotion') }}
        </a-button>
      </div>
    </div>

    <a-row :gutter="24" class="my-3">
      <a-col :span="12">
        <div class="d-flex align-items-center">
          <a-input v-model="search" class="w-100" allow-clear @pressEnter="handleSearch" />
          <a-button class="ml-2" type="danger" icon="search" @click="handleSearch">
            {{ $t('productAvailability.search') }}
          </a-button>
        </div>
      </a-col>
      <!-- <a-col :span="4">
        <a-select
          :value="$route.query.order"
          :placeholder="'Urutkan'"
          class="w-100"
          allow-clear
        >
          <a-select-option
            v-for="(item) in sorting_optional"
            :key="item.label"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :span="4">
        <a-select
          :value="$route.query.order"
          :placeholder="'Filter'"
          class="w-100"
          allow-clear
        >
          <a-select-option
            v-for="(item) in filter_optional"
            :key="item.label"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-col> -->
    </a-row>
  
    <div class="product-availability__utils">
      <a-tabs
        type="card"
        :default-active-key="$route.query.status || 'ALL'"
      >
        <a-tab-pane key="ALL">
          <template #tab>
            <span>
              {{ $t('promotion.active') }}
            </span>
            <span class="ml-2">
              <a-tag :color="$route.query.status === 'ALL' || $route.query.status === undefined ? 'blue' : ''">{{ totalAllData }}</a-tag>
            </span>
          </template>
        </a-tab-pane>
        <!-- <a-tab-pane key="WAITING_APPROVAL">
          <template #tab>
            <span>
              Akan Datang
            </span>
            <span class="ml-2">
              <a-tag :color="$route.query.status === 'WAITING_APPROVAL' ? 'blue' : ''">12</a-tag>
            </span>
          </template>
        </a-tab-pane>
        <a-tab-pane key="ACTIVE">
          <template #tab>
            <span>
              Draft
            </span>
            <span class="ml-2">
              <a-tag :color="$route.query.status === 'ACTIVE' ? 'blue' : ''">42</a-tag>
            </span>
          </template>
        </a-tab-pane>
        <a-tab-pane key="INACTIVE">
          <template #tab>
            <span>
              Telah Berakhir
            </span>
            <span class="ml-2">
              <a-tag :color="$route.query.status === 'INACTIVE' ? 'blue' : ''">25</a-tag>
            </span>
          </template>
        </a-tab-pane> -->
      </a-tabs>
    </div>

    
    <a-table
      :pagination="false"
      class="mt-2"
      :columns="columnsListPromoChannel"
      :data-source="dataPromoChannel"
      :loading="loadingFetchListPromotion"
    >
      <template slot="slot_product_info" slot-scope="text, record, index">
        <div class="d-flex" style="gap: 10px">
          <img :src="`https://picsum.photos/id/${index + 1}/70`" alt="" style="border-radius: 10px;" />
          <div style="font-size: 12px; color: #1c1c1c">
            {{ text }}
          </div>
        </div>
        <a href="#" style="font-size: 12px; text-decoration: none; &:hover { text-decoration: underline; }">{{ $t('promotion.view_product') }}</a>
      </template>
      <template slot="slot_periode" slot-scope="text, record">
        <div>
          <div>{{ $t('promotion.promotion_date') }}</div>
          <div class="mb-2" style="font-size: 12px; color: gray;">
            {{ $moment.unix(record.start_time).format('DD MMM YYYY - HH:mm') }}
          </div>
        </div>
        <div>
          <div>{{ $t('promotion.end_date') }}</div>
          <div class="mb-2" style="font-size: 12px; color: gray;">
            {{ $moment.unix(record.end_time).format('DD MMM YYYY - HH:mm') }}
          </div>
        </div>
      </template>
      <template slot="slot_sync" slot-scope="text, record">
        <div>
          <div>{{ $t('promotion.sync_date') }}</div>
          <div style="font-size: 12px; color: gray;">
            {{ record.sync }}
          </div>
        </div>
      </template>
      <template slot="slot_status" slot-scope="text">
        <a-tag :color="getTagColorByText(text)">
          {{ getStatusLabel(text) }}
        </a-tag>
      </template>
      <template slot="slot_action" slot-scope="text, record">
        <a-dropdown v-if="record.status?.toUpperCase() !== 'EXPIRED'" :trigger="['click']" placement="bottomRight">
          <template #overlay>
            <a-menu>
              <a-menu-item
                key="1"
                @click="$router.push({ path: `/promotion-channel/${$route.params.id}/edit/${record.promotion_id}`, params: { id: record.channel_id, promotionId: record.promotion_id }, query: { ...$route.query }})"
              >
                <a-icon type="edit" /> {{ $t('utils.edit') }}
              </a-menu-item>
              <a-menu-item key="2" @click="handleSingleSyncPromotion(record)">
                <a-icon type="sync" /> {{ $t('promotion.sync_promotion') }}
              </a-menu-item>
              <a-menu-item v-if="record.status?.toUpperCase() === 'ONGOING'" key="3" @click="handleNonActivePromotion(record)">
                <a-icon type="stop" /> {{ $t('promotion.deactivate') }}
              </a-menu-item>
              <a-menu-item v-if="record.status?.toUpperCase() === 'UPCOMING'" key="4" @click="handleDeletePromotion(record)">
                <a-icon type="delete" /> {{ $t('promotion.delete_promotion') }}
              </a-menu-item>
            </a-menu>
          </template>
          <a-button>
            {{ $t('promotion.action') }} <span><a-icon class="ml-2" type="down" /></span>
          </a-button>
        </a-dropdown>
      </template>
    </a-table>

    <EmptyInfo
      v-if="!dataPromoChannel.length"
      class="py-4"
      :title="$t('utils.no_data')"
    />

    <Pagination
      v-if="dataPromoChannel.length"
      class="text-right"
      :total="pagination.total_items"
      :page-size="pagination.size"
      :total-length-per-page="dataPromoChannel.length"
      :default-page="page"
      @changePage="changePage"
    />
    <ModalNonActivePromotion
      ref="modalNonActivePromotion"
      :visible="visibleModalNonActivePromotion"
      :item="itemNonActivePromotion"
      @refetchPromotionChannelList="fetchPromotionChannelList"
      @close="handleCloseModalNonActivePromotion"
      @confirm="handleConfirmModalNonActivePromotion"
    />
  </div>
</template>

<script>
import TableBorder from '@/components/Table/TableBorder.vue'
import Pagination from '@/components/Pagination/index.vue'
import EmptyInfo from '@/components/EmptyInfo'
import useQueryParam from '@/composable/useQueryParam'
import {
  getShopeePromotionChannelList,
  getShopeePromotionChannelDetail,
  createShopeePromotionChannel,
  syncAllShopeePromotionChannel,
  syncSingleShopeePromotionChannel,
  updateShopeePromotionChannel,
  deleteShopeePromotionChannel,
  getShopeeSyncProcessStatus,
  nonActiveShopeePromotionChannel,
} from '@/api/channels/shopee'
import { Modal } from 'ant-design-vue';
import ModalNonActivePromotion from '@/views/products/promo-channel/modal/ModalNonActivePromotion.vue'

export default {
  name: 'PromoChannel',
  components: {
    TableBorder,
    Pagination,
    EmptyInfo,
    ModalNonActivePromotion,
  },
  setup() {
    const { to } = useQueryParam()
    return {
      to,
    }
  },
  data() {
    return {
      sorting_optional: [],
      dataPromoChannel: [],
      loadingFetchListPromotion: false,
      loadingSyncPromotion: false,
      loadingSingleSyncPromotion: false,
      totalAllData: 0,
      page: 1,
      pagination: {
        total_items: 0,
        size: 10,
      },
      visibleModalNonActivePromotion: false,
      itemNonActivePromotion: {},
      search: '',
      mappingWarehouseList: [],
      channels: ['blibli_id', 'lazada_id', 'shopee_id', 'tokopedia_id', 'tiktok', 'tiktok_id'],
    }
  },
  computed: {
    filter_optional() {
      return [
        { label: this.$t('utils.all'), value: 'ALL' },
        { label: this.$t('promotion.active'), value: 'ACTIVE' },
        { label: this.$t('promotion.inactive'), value: 'INACTIVE' },
      ]
    },
    columnsListPromoChannel() {
      return [
        {
          title: this.$t('promotion.promotion_name'),
          dataIndex: 'promotion_name',
          key: 'promotion_name',
        },
        {
          title: this.$t('promotion.period'),
          dataIndex: 'start_time',
          key: 'start_time',
          scopedSlots: {
            customRender: 'slot_periode',
          },
        },
        {
          title: this.$t('promotion.status'),
          dataIndex: 'status',
          key: 'status',
          scopedSlots: {
            customRender: 'slot_status',
          },
        },
        {
          title: this.$t('promotion.action'),
          dataIndex: 'action',
          key: 'action',
          scopedSlots: {
            customRender: 'slot_action',
          },
        },
      ]
    },
    businessId() {
      return this.$store.state.user.restriction_base === 'Warehouse'
        ? this.$store.getters['user/getBusinessIdOnRoleWarehouseOperator'](this.$route.query.warehouse_id)
        : this.$route.query.business_id
    },
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(value) {
        if (this.channels.includes(this.$route.query.channel_code) && this.$store.state.user.restriction_base === 'Warehouse') {
          this.getWarehouseChannelList()
        }
      },
    },
  },
  mounted() {
    this.fetchPromotionChannelList()
  },
  methods: {
    async getWarehouseChannelList() {
      this.mappingWarehouseList = []
      try {
        const normalized = await this.$store.dispatch('warehouse/GETWAREHOUSECHANNELLISTV2', {
          business_id: this.businessId,
          channel_id: this.$route.params.id,
          channel_code: this.$route.query.channel_code,
        })
        this.mappingWarehouseList = normalized
      } catch (err) {
        console.error(err)
        this.mappingWarehouseList = []
      }
    },
    handleSearch() {
      this.fetchPromotionChannelList()
    },
    changePage(page) {
      this.page = page
      this.fetchPromotionChannelList()
    },
    handleDeletePromotion(item) {
      Modal.confirm({
        title: this.$t('promotion.delete_promotion'),
        content: () => {
          return (
            <div>
              {this.$t('promotion.delete_confirm', { name: item.promotion_name })}
            </div>
          )
        },
        okText: this.$t('utils.yes'),
        cancelText: this.$t('utils.no'),
        onOk: async () => {
          await this.onDeletePromotion(item)
        },
      })
    },
    async onDeletePromotion(item) {
      const { promotion_id, promotion_name } = item
      try {
        this.$notification.info({
          message: this.$t('promotion.sync_process_desc', { name: promotion_name }),
          duration: 0,
          button: null,
          icon: <a-icon type="loading" spin />,
        })
        await deleteShopeePromotionChannel({
          business_id: this.$route.query.business_id,
          channel_id: this.$route.params.id,
          promotion_id,
        })
        this.$notification.destroy()
        this.$notification.success({
          message: this.$t('promotion.delete_success'),
        })
        this.page = 1
        this.fetchPromotionChannelList()
      } catch (error) {
        let errorMessages = 'Terjadi kesalahan, gagal menghapus promosi'
        console.error('Error deleting promotion channel:', error) 
        if (error.response?.data?.message) {
          errorMessages = error.response.data.message
        }
        this.$notification.destroy()
        this.$notification.error({
          message: errorMessages,
        })
      } finally {
      }
    },
    async handleNonActivePromotion(item) {
      this.visibleModalNonActivePromotion = true
      this.itemNonActivePromotion = item
    },
    handleCloseModalNonActivePromotion() {
      this.visibleModalNonActivePromotion = false
      this.itemNonActivePromotion = {}
    },
    async handleConfirmModalNonActivePromotion() {
      this.visibleModalNonActivePromotion = false
    },
    async handleSingleSyncPromotion(item) {
      const { promotion_id, promotion_name } = item
      try {
        this.loadingSingleSyncPromotion = true
        this.$notification.info({
          message: this.$t('promotion.sync_process_title'),
          description: () => {
            return (
              <div>
                {this.$t('promotion.sync_process_desc', { name: promotion_name })}
              </div>
            )
          },
          duration: 0,
          icon: <a-icon type="loading" spin />,
        })
        const { data } = await syncSingleShopeePromotionChannel({
          channel_id: this.$route.params.id,
          promotion_id,
          business_id: this.$route.query.business_id,
        })
        if (data?.data?.sync_status?.toUpperCase() === 'ON_PROCESS') {
          setTimeout(() => {
            this.actionCheckProgressSync(data?.data?.request_id)
          }, 2000)
        } else if (data?.data?.sync_status?.toUpperCase() === 'COMPLETED') {
          this.actionSuccessSync()
        }
      } catch (error) {
        let errorMessages = 'Terjadi kesalahan, gagal sync promo'
        console.error('Error syncing promotion channel:', error)
        if (error.response?.data?.message) {
          errorMessages = error.response.data.message
        }
        this.$notification.destroy()
        this.$notification.error({
          message: errorMessages,
        })
      } finally {
        this.loadingSingleSyncPromotion = false
      }
    },
    actionSuccessSync() {
      this.$notification.destroy()
      this.$notification.success({
        message: this.$t('promotion.sync_success'),
      })
      this.page = 1
      this.fetchPromotionChannelList()
    },
    async actionCheckProgressSync(request_id) {
      try {
        const { data } = await getShopeeSyncProcessStatus({
          business_id: this.$route.query.business_id,
          channel_id: this.$route.params.id,
          request_id,
        })
        if (data?.data?.toUpperCase() === 'ON_PROCESS') {
          setTimeout(() => {
            this.actionCheckProgressSync(request_id)
          }, 5000)
        } else if (data?.data?.toUpperCase() === 'COMPLETED') {
          this.actionSuccessSync()
        } else {
          this.$notification.destroy()
          return this.$notification.error({
            message: this.$t('promotion.sync_failed'),
          })
        }
      } catch (error) {
        console.error('Error syncing promotion channel:', error)
        setTimeout(() => {
          this.actionCheckProgressSync(request_id)
        }, 5000)
      }
    },
    async handleSyncPromotion() {
      try {
        this.loadingSyncPromotion = true
        const { data } = await syncAllShopeePromotionChannel({
          channel_id: this.$route.params.id,
          business_id: this.$route.query.business_id,
        })
        if (data?.data?.sync_status?.toUpperCase() === 'ON_PROCESS') {
          this.$notification.info({
            message: this.$t('promotion.sync_process_title'),
            duration: 0,
            icon: <a-icon type="loading" spin />,
          })
          setTimeout(() => {
            this.actionCheckProgressSync(data?.data?.request_id)
          }, 2000)
        } else if (data?.data?.sync_status?.toUpperCase() === 'COMPLETED') {
          this.actionSuccessSync()
        }
      } catch (error) {
        let errorMessages = 'Terjadi kesalahan, gagal sync promo'
        console.error('Error syncing promotion channel:', error)
        if (error.response?.data?.message) {
          errorMessages = error.response.data.message
        }
        this.$notification.error({
          message: errorMessages,
        })
      } finally {
        this.loadingSyncPromotion = false
      }
    },
    getStatusLabel(status) {
      if (!status) return ''
      const lowerStatus = status.toLowerCase()
      const key = lowerStatus === 'expire' ? 'expired' : lowerStatus
      const translated = this.$t(`promotion.${key}`)
      // fallback to original status if translation key is missing
      return translated.startsWith('promotion.') ? status.toUpperCase() : translated
    },
    getTagColorByText(status) {
      if (!status) return ''
      switch(status.toLowerCase()) {
        case 'upcoming':
          return 'blue'
        case 'ongoing':
          return 'green'
        case 'expire':
        case 'expired':
          return 'red'
        default:
          return ''
      }
    },
    async fetchPromotionChannelList() {
      try {
        this.loadingFetchListPromotion = true
        const { data } = await getShopeePromotionChannelList({
          channel_id: this.$route.params.id,
          business_id: this.$route.query.business_id,
          params: {
            page: this.page,
            size: this.pagination.size,
            q: this.search,
          },
        })
        if (data.data.promotion_list?.length > 0) {
          this.dataPromoChannel = data.data.promotion_list
          this.pagination.total_items = data.data.record_count
          this.totalAllData = data.data.record_count
        }
        this.loadingFetchListPromotion = false
      } catch (error) {
        this.loadingFetchListPromotion = false
        console.error('Error fetching promotion channel list:', error)
        this.$message.error('Failed to fetch promotion channel list')
      }
    },
  },
}
</script>

<style lang="scss">
.title-product__availability {
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 26px;
  color: #1c1c1c;
}

// .search__button {
//   color: #fff !important;
//   background:#2196F3 !important;
// }

.inbound__button {
  color: #FF0854 !important;
  background:#FFF !important;
  border-color:#FF0854 !important;
}
.adjustment__button {
  color: #fff !important;
  background:#FF0854 !important;
}

.sync__button {
  color: black !important;
  background:#FFF !important;
  border: 1px solid #ecedee !important;
  &:hover {
    background: #ecedee !important;
  }
}

.program {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: #2196F3;
}

.type {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.01em;
  color: #495057
}
.align-top {
  vertical-align: top;
}
</style>

<style>
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>